export const frequencyOptions = [
    { value: 'Weekly', label: 'Weekly' },
    { value: 'Bi-Weekly', label: 'Bi-Weekly' },
    { value: 'Semi-Monthly', label: 'Semi-Monthly' },
    { value: 'Monthly', label: 'Monthly' }
]

export const payOnHolidayOptions = [
    { value: 'Before', label: 'Before' },
    { value: 'After', label: 'After' },
]

export const dayOfWeekOptions = [
    { value: 'Monday', label: 'Monday' },
    { value: 'Tuesday', label: 'Tuesday' },
    { value: 'Wednesday', label: 'Wednesday' },
    { value: 'Thursday', label: 'Thursday' },
    { value: 'Friday', label: 'Friday' },
    { value: 'Saturday', label: 'Saturday' },
    { value: 'Sunday', label: 'Sunday' }
]
